import {
    noop,
} from 'lodash'
import BulkUploadPopupWrapper from 'app/shared-components/BulkUploadPopupWrapper'

// this is dummy popup to check if filters are pulled correctly and
// correct popup is triggered when multiple tabs
const EngagementsDemoBulkUploadPopup = ({
    name,
}: { name: string }) => {
    return (
        <BulkUploadPopupWrapper
            onClose={noop}
            renderChildren={({
                filtersData, closePopup,
            }) => {
                return (
                    <div>
                        tab:
                        {name}
                        <br />
                        bulk upload filters:
                        {' '}
                        {JSON.stringify(filtersData)}
                        <br />
                        <button
                            onClick={closePopup}
                            type="button"
                        >
                            close
                        </button>
                    </div>
                )
            }}
        />
    )
}

export default EngagementsDemoBulkUploadPopup
